var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "touchpoint-overview-row",
        { staticClass: "info-row info-row-header" },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c("touchpoint-overview-icon-circle", {
                staticClass: "info-circle",
                attrs: { color: "blue" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("template", { slot: "center" }, [
            _c("span", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.direction))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("i", {
              staticClass: "fas fa-3x fa-long-arrow-alt-right direction-marker"
            })
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "right" },
            [
              _c("touchpoint-overview-icon-circle", {
                staticClass: "info-circle",
                attrs: { color: "green" }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(_vm.connectionsInfo, function(connectionInfo) {
        return _c("touchpoint-info-connection-list-row", {
          key: connectionInfo.connectionId,
          staticClass: "info-row",
          attrs: {
            "connection-name": connectionInfo.connectionName,
            "source-brick-name": connectionInfo.sourceBrickName,
            "source-brick-type": connectionInfo.sourceBrickType,
            "source-brick-config": connectionInfo.sourceBrickConfig,
            "destination-brick-name": connectionInfo.destinationBrickName,
            "destination-brick-type": connectionInfo.destinationBrickType,
            "destination-brick-config": connectionInfo.destinationBrickConfig,
            "source-conditions": connectionInfo.sourceConditions,
            "destination-condition-description":
              connectionInfo.destinationConditionDescription
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }